/* eslint-disable import/no-cycle */
import { FieldValues } from "react-hook-form";
import { Loading, Typography } from "@kitbird/core";
import styled from "styled-components";
import Modal from "../../../../components/Modal";
import UserPositionForm from "./UserPositionForm/UserPositionForm";
import { useUserPosition } from "../Provider";

type optionsType = {
  label: string;
  value: string;
};
export interface PlacementFields extends FieldValues {
  type_code: string;
  placement: Array<{
    area: optionsType;
    pool: optionsType;
    department: optionsType;
    position: optionsType;
    segment?: optionsType;
    roles?: optionsType;
  }>;
  replacement_user?: {
    nip: string;
    nama: string;
  };
}

const MODAL_TYPES = {
  CREATE: "CREATE",
  EDIT: "EDIT",
  DELETE: "DELETE",
} as const;

const MODAL_TITLES = {
  CREATE: "Tambah",
  EDIT: "Edit",
} as const;

const ModalContentWrapper = styled.div`
  padding: 1rem;
`;

const CreateUserModal = () => {
  const {
    modal, setModal, user, isLoadingUser, setSelectedRow, errorUser,
  } = useUserPosition();

  const handleCloseModal = () => {
    setModal("");
    setSelectedRow(undefined);
  };

  const isModalOpen = modal === MODAL_TYPES.CREATE || modal === MODAL_TYPES.EDIT;
  const isEditMode = modal === MODAL_TYPES.EDIT;
  const isCreateMode = modal === MODAL_TYPES.CREATE;

  const getModalTitle = (): string => {
    if (!isModalOpen) return "";
    const title = MODAL_TITLES[modal as keyof typeof MODAL_TITLES];
    return title ? `${title} data - User` : "";
  };

  const renderModalBody = () => {
    if (isEditMode) {
      if (isLoadingUser) {
        return (
          <ModalContentWrapper>
            <Loading variant="line" />
          </ModalContentWrapper>
        );
      }

      if (errorUser) {
        return (
          <ModalContentWrapper>
            <Typography level={5} color="error">
              Error fetching user
            </Typography>
          </ModalContentWrapper>
        );
      }

      return <UserPositionForm setOpen={handleCloseModal} defaultData={user} />;
    }

    if (isCreateMode) {
      return <UserPositionForm setOpen={handleCloseModal} />;
    }

    return null;
  };

  return (
    <Modal
      styleBody={{
        padding: "0",
        overflow: "hidden",
      }}
      title={getModalTitle()}
      isOpen={isModalOpen}
      setOpen={handleCloseModal}
      body={renderModalBody()}
    />
  );
};

export default CreateUserModal;
